import { render, staticRenderFns } from "./ConvertPointsDialog.vue?vue&type=template&id=626b00fb&scoped=true"
import script from "./ConvertPointsDialog.vue?vue&type=script&lang=js"
export * from "./ConvertPointsDialog.vue?vue&type=script&lang=js"
import style0 from "./ConvertPointsDialog.vue?vue&type=style&index=0&id=626b00fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626b00fb",
  null
  
)

export default component.exports